import { environment } from '../../environments/environment';
import { classifyHostname, type DeploymentContext } from './deployment-context';

interface RuntimeConfigBlock {
  ecommerceApiUrl?:    string;
  softionBrandingUrl?: string;
  managementAppUrl?:   string;
}

interface RuntimeConfigFile {
  tenant:  RuntimeConfigBlock;
  demo:    RuntimeConfigBlock;
  softion: RuntimeConfigBlock;
}

export async function applyRuntimeConfig(hostname: string): Promise<DeploymentContext> {
  const context = classifyHostname(hostname);

  // Fuera de producción (ng serve local, QA) cada build ya trae sus propios valores
  // correctos en environment.ts/environment.qa.ts — mezclar el runtime-config de
  // producción encima los pisaría silenciosamente (ej. apuntar el dev local al API real).
  if (!environment.production) return context;

  const isDemoKind = context.kind === 'demo' || context.kind === 'demo-link';

  Object.assign(environment, {
    isDemo:      isDemoKind,
    isSoftion:   context.kind === 'softion',
    showDocs:    context.kind === 'softion',
    demoEnabled: isDemoKind || context.kind === 'softion',
  });

  try {
    const res = await fetch('/assets/runtime-config.json', { signal: AbortSignal.timeout(3000) });
    if (!res.ok) return context;
    const file = (await res.json()) as RuntimeConfigFile;
    // demo-link (hostname fijo demo-webly.*) no tiene bloque propio — usa el mismo bloque "demo".
    const blockKey = context.kind === 'demo-link' ? 'demo' : context.kind;
    const block = file[blockKey];
    if (block) Object.assign(environment, block);
  } catch {
    // Fail-open: el sitio sigue con los valores por defecto del build (environment.prod.ts)
  }

  return context;
}
